export default __webpack_public_path__ + "img/9a0bb6fd32b2ab81b51ec970471344eb.png";